import { useTranslation } from "shared/contexts/I18nContext";
// A collapsible drawer for displaying pending enrollment requests.
const RightDrawer = ({ children, title, count, isOpen, toggleDrawer }) => {
    const { t } = useTranslation();
    return (
        <div className={`relative bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 transition-all duration-300 ease-in-out
            ${isOpen ? 'w-full md:w-1/2' : 'w-8 md:w-8'} flex-shrink-0`}>

            <div className="absolute inset-y-0 left-0 flex items-center justify-center w-8 group">
                <button onClick={toggleDrawer} className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 focus:outline-none">
                    {isOpen ? (
                        <svg className="w-6 h-6 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>

                    ) : (
                        <svg className="w-6 h-6 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path></svg>

                    )}
                </button>
                {!isOpen && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-full mr-2 px-2 py-1 bg-gray-700 text-white text-xs rounded whitespace-nowrap invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                        {t(title)} ({count})
                    </div>
                )}
            </div>

            {isOpen && (
                <div className="pl-8 h-full">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
                            {t(title)}
                        </h2>
                    </div>
                    <div className="overflow-y-auto h-[calc(100%-2.5rem)]">
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};
export default RightDrawer;
